import { useEffect, useState } from "react";
import AlertMessage from "../common/AlertMessage";
import React from "react";
import { formateComponentName } from "../../utils/common";

interface FormViewState {
    elementName: string,
    formType: string,
    templateType: string,
}

const FormViewer: React.FC<FormViewState> = (props) => {
  const { elementName, formType, templateType } = props;
  const [alertMessage, setAlertMessage] = useState("");

  useEffect(()=>{
    setAlertMessage('')
    setTimeout(()=>{
        const tags = document.getElementsByClassName('custom-highlight');
        let tag;
        if (tags && tags.length > 0) {
          tag = tags[0];
          tag.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        else
          setAlertMessage("Does not reflect on the UI.")
    },700)
  },[elementName, formType])

      const selectedComponent = () => {
        try {
          if (formType === undefined || formType === null || formType === "") 
            throw "form type is undefined";
        else
            return import(`./formview/${formateComponentName(formType.replaceAll("/", " "))}View`)
        }
        catch {
          return Promise.resolve({ default: () => null });
        }
    };

    const Component = React.lazy(() => selectedComponent());


  return (
    <>
      <div style={{ alignContent: 'flex-start' }}>
        <AlertMessage
          message={alertMessage}
          onClose={() => setAlertMessage("")}
          variant={"success"}
        />
        <React.Suspense fallback={<></>}>
        {Component && <Component elementName={elementName}/>}
        </React.Suspense>
      </div>
    </>
  );
};

export default FormViewer;
